import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=fe0459cc&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=fe0459cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0459cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe0459cc')) {
      api.createRecord('fe0459cc', component.options)
    } else {
      api.reload('fe0459cc', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=fe0459cc&scoped=true&", function () {
      api.rerender('fe0459cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ectbygNkngya/JS/comp/PopupBox.vue"
export default component.exports